import { gql } from '@apollo/client';

// Operation names deliberately differ from the backend field names AND from
// the schema payload types (SubmitHomeworkMutation / UpsertHomeworkAssignmentMutation /
// RerunHomeworkAiReviewMutation) — an operation named `SubmitHomework` would
// generate a result type `SubmitHomeworkMutation` that collides with the
// schema type of the same name.

/**
 * Student submission: githubUrl and/or file — at least one, both allowed
 * (spec 0012 rev.3). Multipart transport for $file comes from
 * apollo-upload-client's createUploadLink, already wired in core/graphql/client.
 */
export const SubmitLessonHomeworkMutation = gql`
  mutation SubmitLessonHomework($lessonId: ID!, $githubUrl: String, $file: Upload) {
    submitHomework(lessonId: $lessonId, githubUrl: $githubUrl, file: $file) {
      success
      customErrors {
        code
        field
        message
      }
      submission {
        id
        githubUrl
        fileName
        status
        attempt
        submittedAt
        hwMark
        teacherComment
      }
    }
  }
`;

/**
 * Teacher creates/edits the lesson assignment (≤ 1 per lesson in v1).
 *
 * ⚠️ Мутация перезаписывает ВСЕ поля задания. Форма обязана слать
 * title/text/textbookRef/dueDate целиком: отправив один только `textbookRef`,
 * она затрёт текст задания.
 *
 * ТЗ 0026: `title`/`text` больше не обязательны — задание можно задать одной
 * строкой «глава 7, задачи 1–4».
 */
export const UpsertLessonHomeworkAssignmentMutation = gql`
  mutation UpsertLessonHomeworkAssignment(
    $lessonId: ID!
    $title: String
    $text: String
    $textbookRef: String
    $dueDate: Date
  ) {
    upsertHomeworkAssignment(
      lessonId: $lessonId
      title: $title
      text: $text
      textbookRef: $textbookRef
      dueDate: $dueDate
    ) {
      success
      customErrors {
        code
        field
        message
      }
      assignment {
        id
        lessonId
        title
        text
        textbookRef
        dueDate
        updatedAt
      }
    }
  }
`;

/** Teacher grades a student — works with or without a submission (spec 0012 §4). */
export const GradeHomeworkSubmissionMutation = gql`
  mutation GradeHomeworkSubmission(
    $lessonId: ID!
    $studentId: ID!
    $hwMark: String!
    $comment: String
    $attempt: Int
  ) {
    gradeHomework(
      lessonId: $lessonId
      studentId: $studentId
      hwMark: $hwMark
      comment: $comment
      attempt: $attempt
    ) {
      success
      customErrors {
        code
        field
        message
      }
      row {
        studentId
        hwMark
        submission {
          id
          status
          teacherComment
          gradedByName
        }
      }
    }
  }
`;

/** Teacher re-runs the AI review; AI_DISABLED code when the flag is off. */
export const RerunSubmissionAiReviewMutation = gql`
  mutation RerunSubmissionAiReview($submissionId: ID!) {
    rerunHomeworkAiReview(submissionId: $submissionId) {
      success
      customErrors {
        code
        field
        message
      }
      aiReviewStatus
    }
  }
`;
